import { render } from "./CDivider.vue?vue&type=template&id=0aee3ba5&scoped=true&ts=true"
import script from "./CDivider.vue?vue&type=script&lang=ts"
export * from "./CDivider.vue?vue&type=script&lang=ts"

import "./CDivider.vue?vue&type=style&index=0&id=0aee3ba5&scoped=true&lang=scss"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aee3ba5"]])

export default __exports__